
import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    projects: {},
    activeProject: null,
    order: [],
    error: null,
    loading: false,
    deletedLoading: false,
    eventRoomSchemes: [],
    schemesLoading: false,
    schemesError: null,
    currentProject: {},
    metaLang: null
};

// const getEventRoomsStart = (state, action) => {
//     return updateObject(state, { error: null, loading: true });
// }

// const getEventRoomsFail = (state, action) => {
//     return updateObject(state, {
//         error: action.error,
//         loading: false
//     });
// }

// const getEventRoomsSuccess = (state, action) => {
//     let newProjects = {},
//         members,
//         project;
//     Object.keys(action.projects).forEach(id => {
//         members = [];
//         project = action.projects[id];
//         const { metadata, clips, ...pData } = project.data;

//         if (project.members) {
//             project.members.forEach((member) => {
//                 members.push(project.membermetadata.members[member].email);
//             });
//             metadata.fields.members = members.join(';');
//         }

//         newProjects[project.id] = { ...pData, metadata: Object.assign({}, metadata.fields), originalObject: project, created: metadata.fields.created };

//     });

//     return updateObject(state, {
//         projects: newProjects, loading: false
//     });
// }

const getDeletedEventRoomsStart = (state, action) => {
    return updateObject(state, { error: null, deletedLoading: true });
}

const getDeletedEventRoomsSuccess = (state, action) => {
    let newProjects = {};
    Object.keys(action.deletedProjects).forEach(id => {
        let project = action.deletedProjects[id];
        const { metadata, clips, ...pData } = project.data;
        newProjects[project.id] = { ...pData, metadata: metadata, originalObject: project, created: metadata.fields.created };

    });

    return updateObject(state, {
        deletedProjects: newProjects, deletedLoading: false
    });
}

// const getEventRoomSchemesSuccess = (state, action) => {
//     return updateObject(state, { eventRoomSchemes: action.payload, schemesLoading: false });
// }

// const getEventRoomSchemesFail = (state, action) => {
//     return updateObject(state, { schemesLoading: false, schemesError: action.payload });
// }

// const getEventRoomSchemesStart = (state, action) => {
//     return updateObject(state, { schemesLoading: true });
// }

const eventRoomDeleted = (state, action) => {
    let delProjects = { ...state.deletedProjects };
    delete (delProjects[action.payload.projectId]);
    return updateObject(state, { deletedProjects: delProjects, deletedLoading: false });
}

const saveNewEventRoom = (state, action) => {
    let maxProjectId = 0;
    for (let project of state) {
        if (project.projectId > maxProjectId) {
            maxProjectId = project.projectId;
            console.log("maxProjectId:" + maxProjectId);
        }
    }
    return state;
}

const setActiveEventRoom = (state, action) => {
    return updateObject(state, { activeProject: action.payload.activeProject });
}

const updateEventRoom = (state, action) => {
    console.log("updating project");
    let members = [];
    let project = action.project;
    const { metadata, clips, ...pData } = project.data;

    project.members.forEach((member) => {
        members.push(project.membermetadata.members[member].email);
    });
    metadata.fields.members = members.join(';');
    let newProject = { ...pData, metadata: Object.assign({}, metadata.fields), originalObject: project };
    return updateObject(state, { projects: updateObject(state.projects, { [project.id]: newProject }) });
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        // case actionTypes.EVENTROOMS_GET_PROJECTS_START: return getEventRoomsStart(state, action);
        // case actionTypes.EVENTROOMS_GET_PROJECTS_SUCCESS: return getEventRoomsSuccess(state, action);
        // case actionTypes.EVENTROOMS_GET_PROJECTS_FAIL: return getEventRoomsFail(state, action);
        case actionTypes.EVENTROOMS_GET_DELETED_PROJECTS_SUCCESS: return getDeletedEventRoomsSuccess(state, action);
        case actionTypes.EVENTROOMS_GET_DELETED_PROJECTS_START: return getDeletedEventRoomsStart(state, action);
        case actionTypes.EVENTROOMS_DELETE_PROJECT_START: return updateObject(state, { deletedLoading: true });
        case actionTypes.EVENTROOMS_DELETE_PROJECT_SUCCESS: return eventRoomDeleted(state, action);
        case actionTypes.EVENTROOMS_DELETE_PROJECT_FAIL: return updateObject(state, { deletedLoading: false });
        case actionTypes.EVENTROOMS_SAVE_NEW_PROJECT: return saveNewEventRoom(state, action);
        case actionTypes.EVENTROOMS_SET_ACTIVE_PROJECT: return setActiveEventRoom(state, action);
        case actionTypes.EVENTROOMS_PROJECT_UPDATE_RECEIVED: return updateEventRoom(state, action);
        // case actionTypes.EVENTROOMS_GET_SCHEMES_START: return getEventRoomSchemesStart(state, action);
        // case actionTypes.EVENTROOMS_GET_SCHEMES_SUCCESS: return getEventRoomSchemesSuccess(state, action);
        // case actionTypes.EVENTROOMS_GET_SCHEMES_FAIL: return getEventRoomSchemesFail(state, action);
        case actionTypes.EVENTROOMS_SET_CURRENT_UPLOADPROJECT: return updateObject(state, { currentProject: action.payload });
        case actionTypes.EVENTROOMS_SET_LOADING: return updateObject(state, { loading: action.payload.loading })
        case actionTypes.EVENTROOMS_SET_METALANG: return updateObject(state, { metaLang: action.payload });
        default: return state;
    }
}

export default reducer;
